// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4c3ba7c3","277":"0f913c4d","614":"ba7b3e10"}[chunkId] + ".chunk.js";
};